import { Button, Dialog, Spinner } from 'construct-ui';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import DatePickerComponent from '../../../components/date-picker/date-picker.component';
import { messageComponent } from '../../../components/message/message.component';
import paginationComponent from '../../../components/pagination/pagination.component';
import { formats as FORMATS } from '../../../config/constants';
import announcementModel from '../../../models/communication/announcement.model';
import languageModel from '../../../models/language.model';
import ViewBase from '../../view-base.view';
import AnnouncementAddView from './announcement-add.view';
import AnnouncementConfirmView from './announcement-confirm.view';
import AnnouncementDetailView from './announcement-detail.view';
import AnnouncementRecipientView from './announcement-recipent-list.view';
import { exportRetailExcelTemplate } from "../../../models/file.model"

export default function AnnouncementView() {

  ViewBase.call(this);

  var inputDatModel = { header: [], details: [], columnCount: 0, rowCount: 0, fieldTypeList: [], statusList: [], totalCount: 0, orderBy: "", pageIndex: 1, pageSize: 10, searchFrom: "", searchTo: "", title: "", announcement: { title: "", content: "" } };
  let list = [
    { title: "Announcement 1", sender: "sender 1", recipients: "100", readRate: "20% (20/100)", createDate: "2022.05.13 10:10", active: "Y" },
    { title: "Announcement 2", sender: "sender 2", recipients: "200", readRate: "30% (30/100)", createDate: "2022.05.13 10:10", active: "Y" },
    { title: "Announcement 3", sender: "sender 3", recipients: "300", readRate: "40% (40/100)", createDate: "2022.05.13 10:10", active: "Y" },
    { title: "Announcement 4", sender: "sender 4", recipients: "400", readRate: "50% (50/100)", createDate: "2022.05.13 10:10", active: "Y" }
  ];
  var isLoading = false;
  var isMsgOpen = false;
  var showMsg = "";
  var msgTitle = "";
  let isViewModalOpen = false;
  let fromInitDate;
  let toInitDate;
  let isConfirmModalOpen = false;
  let isRecipientOpen = false;
  let detailType = "";
  let isAnnouncementAddOpen = false;
  let uploadedFiles = [];
  let announcementId = "";
  let changedStatus = "";

  let getTitle = (e) => {
    inputDatModel.title = e.target.value;
  }

  let recipientViewClosed = (e) => {
    isRecipientOpen = false;
  }

  let recipientViewOpen = (item) => {
    detailType = "";
    announcementId = item.announcementID;
    isRecipientOpen = true;

  }

  let onStatusChange = (e) => {
    changedStatus = e == "Y" ? "001" : "002";
    isViewModalOpen = false;
    isConfirmModalOpen = true;
  };

  let onTypeChanged = (e) => {
    isViewModalOpen = false;
    isRecipientOpen = true;
    detailType = e;
  };

  let confirmViewClosed = () => {
    isViewModalOpen = true;
    isConfirmModalOpen = false;
  }

  let _clearFilter = () => {
    inputDatModel.title = "";
    _initControls();
  }

  let _search = () => {
    inputDatModel.pageIndex = 1;
    _loadAnnonceList();
  }

  let _loadAnnonceList = () => {
    isLoading = true;
    let request = {
      pageIndex: inputDatModel.pageIndex, pageSize: inputDatModel.pageSize, fromDate: inputDatModel.searchFrom,
      toDate: inputDatModel.searchTo, title: inputDatModel.title
    };
    announcementModel.getAnnouncementList(
      _announcementListSuccessCallBack,
      _announcementListErrorCallBack,
      request
    )
  }

  let _announcementListSuccessCallBack = (result) => {
    isLoading = false;
    inputDatModel.statusList = [];
    list = result.data;
    inputDatModel.totalCount = result.total;
    inputDatModel.pageIndex = result.pageIndex;
    inputDatModel.pageSize = result.pageSize;
  }

  let _announcementListErrorCallBack = (error) => {
    isLoading = false;
    this.handleError(error);
  }

  let _initControls = () => {
    fromInitDate = moment().add(-3, 'month').format(FORMATS.dateFormat);
    toInitDate = moment().format(FORMATS.dateFormat);
    inputDatModel.searchFrom = moment().add(-3, 'month').format(FORMATS.apiDateFormat);
    inputDatModel.title = "";
    inputDatModel.searchTo = moment().format(FORMATS.apiDateFormat);
    _loadAnnonceList();
  }

  const _downloadExcel = () => {
    this.showLoading();
    const fileName = `Announcement_${uuidv4()}`;
    const exportConfig = {
      storedProcedureCode: "2",
      params: [
        { code: "13", value: inputDatModel.title },
        { code: "15", value: "" },
        { code: "14", value: "" },
        { code: "8", value: inputDatModel.searchFrom },
        { code: "9", value: inputDatModel.searchTo },
        { code: "2", value: "" },
        { code: "17", value: "EN" }],
      excelSheetNames: ["Announcement Count"]
    };
    exportRetailExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDatModel.pageIndex = pageIndex;
    inputDatModel.pageSize = pageSize;
    _loadAnnonceList();
  }

  let onPageChanged = (pageIndex) => {
    inputDatModel.pageIndex = pageIndex;
    _loadAnnonceList();
  }

  let _loadDetailsView = (item) => {

    announcementId = item.announcementID;
    isViewModalOpen = true;
  }

  let _registerAnnouncement = () => {

    isAnnouncementAddOpen = true;
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _detailViewClosed = () => {
    isViewModalOpen = false;
  }

  let _changeStatus = () => {
    announcementModel.announcementChangeStatus(
      (result) => {
        _detailViewClosed();
        _loadAnnonceList();
        isMsgOpen = true;
        showMsg = result[0].transStatus;
        msgTitle = this.getText(result[0].code, result[0].message);
        isConfirmModalOpen = false;
        isViewModalOpen = true;
      },
      (error) => {
        this.handleError(error);
      },
      announcementId, changedStatus
    )
  }

  let onSaveComplete = (result) => {
    isAnnouncementAddOpen = false;
    isMsgOpen = true;
    showMsg = result[0].transStatus;
    msgTitle = this.getText(result[0].code, result[0].message);
    _loadAnnonceList();
  }

  let _onDatePickerChange = (e) => {
    fromInitDate = moment(e.detail.start).format(FORMATS.dateFormat);
    toInitDate = moment(e.detail.end).format(FORMATS.dateFormat);
    inputDatModel.searchFrom = moment(e.detail.start).format(FORMATS.apiDateFormat);
    inputDatModel.searchTo = moment(e.detail.end).format(FORMATS.apiDateFormat);
  }

  return {
    oninit: () => {
      _initControls();
    },
    view: () => {
      return [
        m('.row',
          m(Spinner, {
            active: isLoading,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.col-12',
            m('.d-flex.justify-content-end.align-items-end.mb-3',
              m('button.btn.btn-outline-primary.btn-add.mb-2',
                { onclick: _registerAnnouncement }, [
                m("i.bi.bi-plus-lg.me-0"),
              ]),
            ),
            m('.card.mb-3',
              m('.card-body',
                m('.row.g-4',
                  m('.col-md-4',
                    m('label.form-label', languageModel.getText("LT00000070", "Date Range")),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      dateStart: fromInitDate, // default date range
                      dateEnd: toInitDate, // default date range
                      onselect: (e) => {
                        _onDatePickerChange(e);
                      }
                    })
                  ),
                  m('.col-md-4',
                    m('label.form-label', languageModel.getText("LT00000037", "Title")),
                    m('input[type=text][placeholder=' + languageModel.getText("LT00000037", "Title") + '][value="' + inputDatModel.title + '"].form-control.form-control-bg', { onchange: getTitle })
                  ),
                  m('.col-md-4.gap-2.d-flex.align-items-end.justify-content-end.justify-content-md-start',
                    m('button.btn.btn-primary', { onclick: _search }, languageModel.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary', { onclick: _downloadExcel },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table.align-middle", [
                        m("thead.thead-bggrey",
                          m("tr.align-middle",
                            [
                              m("th.ps-4", { "scope": "col" }, languageModel.getText("LT00000037", "Title")),
                              m("th", { "scope": "col" }, languageModel.getText("LT00000038", "Sender")),
                              m("th", { "scope": "col" }, languageModel.getText("LT00000039", "Recipients")),
                              m("th", { "scope": "col" }, languageModel.getText("LT00000040", "Read Rate")),
                              m("th", { "scope": "col" }, languageModel.getText("LT00000041", "Create Date")),
                              m("th", { "scope": "col" }, languageModel.getText("LT00000025", "Active"))
                            ])
                        ),
                        m("tbody",
                          list.length == 0 &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": "7" }, languageModel.getText("EM00000141", "No records found."))
                          ),
                          list.map(gc => [
                            m("tr", {
                              "data-bs-toggle": "collapse",
                              "data-bs-target": "#gc_collapse_" + gc.index,
                              "aria-expanded": "false",
                              "aria-controls": "gc_collapse_" + gc.index
                            }, [
                              m("td", { style: "width:40%;white-space: break-spaces;" }, m('button.btn.btn-link.py-0', { onclick: () => { _loadDetailsView(gc) } }, gc.title)),
                              m("td", gc.createUserName),
                              m("td", m('button.btn.btn-link.py-0', { onclick: () => { recipientViewOpen(gc) } }, gc.totalCount)),
                              m("td", ((gc.readCount / gc.totalCount) * 100).toString().split('.').length == 1 ? (gc.readCount / gc.totalCount) * 100 + '% (' + gc.readCount + '/' + gc.totalCount + ')' : ((gc.readCount / gc.totalCount) * 100).toString().split('.')[0] + '.' + Math.round(('0.' + ((gc.readCount / gc.totalCount) * 100).toString().split('.')[1]) * 100) + '% (' + gc.readCount + '/' + gc.totalCount + ')'),
                              m("td", gc.createDate),
                              m("td",
                                gc.statusName === 'Active' ?
                                  m('span.badge.rounded-pill.green-bg-status',
                                    gc.statusName,
                                  ) :
                                  m('span.badge.rounded-pill.grey-bg-status',
                                    gc.statusName,
                                  ),
                              )
                            ])
                          ]),
                        )
                      ])
                    ),
                    !isLoading &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: inputDatModel.pageIndex,
                        pageSize: inputDatModel.pageSize,
                        totalItems: inputDatModel.totalCount,
                        onPageChanged: onPageChanged,
                        onPageSizeChanged: onPageSizeChanged
                      })
                    )
                  )
                )
              )
            )
          ),
          m(Dialog, {
            isOpen: isViewModalOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isViewModalOpen = false; },
            title: this.getText("LT00000042", "Announcement Details"),
            content: m(AnnouncementDetailView, { onStatusChange: onStatusChange, onTypeChanged: onTypeChanged, announcementId: announcementId }),
            "class": "cui-dialog-xxl",
            footer: [
              m('.d-flex.justify-content-end',
                m(Button, {
                  label: this.getText("LT00000021", "Close"),
                  intent: 'primary',
                  onclick: _detailViewClosed
                })
              )
            ]
          }),
          m(Dialog, {
            isOpen: isConfirmModalOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isConfirmModalOpen = false; },
            title: this.getText("LT00000043", "Confirm"),
            content: m(AnnouncementConfirmView, { changedStatus: changedStatus }),
            "class": "cui-dialog",
            footer: [
              m(Button, {
                label: this.getText("LT00000024", "No"),
                onclick: confirmViewClosed
              }),
              m(Button, {
                loading: this.isSubmitting,
                label: this.getText("LT00000023", "Yes"),
                intent: 'primary',
                onclick: _changeStatus
              })
            ]
          }),
          m(Dialog, {
            isOpen: isRecipientOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isRecipientOpen = false; },
            title: this.getText("LT00000053", "Recipient List"),
            content: m(AnnouncementRecipientView, { detailType: detailType, announcementId: announcementId, statusSelectionNeed: 'Y' }),
            "class": "cui-dialog-xxl",
            footer: [
              m('.d-flex.justify-content-end',
                m(Button, {
                  label: this.getText("LT00000021", "Close"),
                  onclick: recipientViewClosed,
                  intent: 'primary'
                })
              ),
            ]
          }),
          m(Dialog, {
            isOpen: isAnnouncementAddOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isAnnouncementAddOpen = false; },
            title: this.getText("LT00000058", "Create"),
            content: m(AnnouncementAddView, { onAddClose: () => { isAnnouncementAddOpen = false }, uploadedFiles: uploadedFiles, onSaveComplete: onSaveComplete }),
            "class": "cui-dialog-xxl",
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ]
    }
  }
}
